module.exports = __webpack_public_path__ + "static/shopify_monei-f3292edad4266e1a0deb9b9726daa64a.svg";